//混入方法,定义通用方法
const mixinModel = {
  data() {
    return {

    }
  },
  props: {
    dModel: {
      type: Object,
      default: function() {
        return {
          key: "",
          label: "",
          model: "",
          type: "",
          rules: []
        }
      }
    },
  },
  computed: {

  },
  methods: {

  },
}

export default mixinModel
